import React from "react";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function getLink(website) {
  let link = "";
  if (website === "") {
  } else {
    if (website.startsWith("http")) link = website;
    else link = `//${website}`;
  }
  return link;
}

export function SponsorCard({ sponsor, onEditSponsor, onDeleteSponsor }) {
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "lightgray",
        padding: "20px",
        marginBottom: "20px",
      }}
    >
      <h6>{sponsor.sponsor_name}</h6>
      <div style={{ margin: 20 }}>
        <img
          src={
            "data:image/" +
            sponsor.sponsor_logo_format +
            ";base64," +
            sponsor.sponsor_logo
          }
          style={{ width: 400 }}
          alt=""
          className="sponsorCardLogo"
        ></img>
      </div>
      {sponsor.sponsor_website === "" ? null : (
        <a
          href={getLink(sponsor.sponsor_website)}
          target="_blank"
          rel="noreferrer"
        >
          {sponsor.sponsor_website}
        </a>
      )}
      <div style={{ marginBottom: 0, paddingBottom: 0 }}>
        <Button
          variant="link"
          onClick={() => onEditSponsor(sponsor.sponsor_id)}
        >
          <FontAwesomeIcon icon="pencil-alt" />
          &nbsp;Edit
        </Button>
        <Button
          variant="link"
          onClick={() => {
            if (window.confirm("Are you sure you wish to delete this sponsor?"))
              onDeleteSponsor(sponsor.sponsor_id);
          }}
        >
          <FontAwesomeIcon icon="trash-alt" />
          &nbsp;Delete
        </Button>
      </div>
      <hr style={{ marginTop: 0, padding: 0 }} />
    </div>
  );
}
